
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import SearchBar from "@/components/ui/SearchBar";
import { toast } from "sonner";
import ActionBanner from "./ActionBanner";

interface IndexHeroProps {
  onSearch: (query: string) => void;
}

const IndexHero: React.FC<IndexHeroProps> = ({
  onSearch
}) => {
  const navigate = useNavigate();
  const handleSearch = (query: string) => {
    try {
      if (query.trim()) {
        navigate(`/explore?q=${encodeURIComponent(query.trim())}`);
      } else {
        navigate('/explore');
      }
    } catch (error) {
      console.error('Search navigation error:', error);
      toast.error('Error processing search. Please try again.');
    }
  };
  
  return (
    <section className="pt-32 pb-24 px-4 sm:px-6 lg:px-8">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center space-y-4 animate-fade-in">
          <Badge variant="secondary" className="mb-4 px-3 py-1 text-xs font-medium rounded-full">
            The Ultimate Prompt Library
          </Badge>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight">
            Boost Your Productivity 10X Using AI Prompts
          </h1>
          <p className="mt-6 text-xl text-muted-foreground max-w-3xl mx-auto">
            Expert-crafted prompts that deliver immediate results. Stop wasting time on trial and error - use what already works
          </p>
          
          <div className="mt-12 mb-16">
            <ActionBanner />
          </div>
          
          <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="rounded-full px-8">
              <Link to="/explore">Explore Prompts</Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="rounded-full px-8 group">
              
            </Button>
          </div>
          
          <div className="mt-8 max-w-3xl mx-auto">
            
          </div>
        </div>
        
        <div className="mt-16 max-w-2xl mx-auto animate-slide-up">
          <SearchBar 
            onSearch={handleSearch} 
            placeholder="Search for prompts by keyword, category, or use case..." 
            className="shadow-sm" 
            triggerMode="submit"
          />
        </div>
      </div>
    </section>
  );
};

export default IndexHero;
